import Notification from './Notification';

export {
    Notification,
};

export default Notification;
